import { useQuery } from '@tanstack/react-query';
import { PaymentsService } from '../services';

export const getACHAuthorizationRecordsQueryKey = (userId) => [
  'GET_ACH_AUTHORIZATION_RECORDS',
  userId,
];

export const useGetACHAuthorizationRecords = (userId, options) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: getACHAuthorizationRecordsQueryKey(userId),
    queryFn: () => PaymentsService.getACHAuthorizationRecords(userId),
    enabled: options?.enabled ?? !!userId,
    retry: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data || [],
    error,
    isError,
    isLoading: isLoading || isFetching,
  };
};
